import { BaseClass } from 'digicon-events-base';
import { i18n } from 'digicon-web-localization/localization';
import { Chart } from 'chart.js/auto';

export class Operations extends BaseClass {
    constructor(properties) {
        super();
        this.modules = properties.modules;
        this.options = "";
        this.chartColors = ["#5083bc", "#c1504c"];
    }

    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    _fillLCOEVarianceAnalysisContainer(forms, screens) {
        document.querySelector('.container-xxl .card-body #content').innerHTML = `<div id="operationsContainer" class="operationsContainer" data-id="100"></div>`;
        document.querySelector('.container-xxl h2').innerText = `${i18n('varianceAnalysis')}`;
        this.options = '<option style="display: none">-</option>';
        for (let i = 0; i < forms.length; i++) {
            if (i != 1) {
                this.options = this.options + `<option value="${forms[i].id}">${forms[i]['name_' + this.modules.localization.getLocale().split('-')[0]]}</option>`;
            }
        }
        document.querySelector('#operationsContainer').innerHTML = `<p class="add_fields" style="font-size: 14px; font-weight: bold;">Add fields <button class="add"><i class="fa fa-plus"></i></button></p><div class='operations'></div><div class="buttons" style="padding-left: 0px; float: left; width: 100%">
            <button type="button" class="btn primary send">${i18n('send')}</button>
        </div><div class="results"></div>`;
        document.querySelector(`.add`).addEventListener('click', async (event) => {
            const nodes = document.querySelectorAll('.operation');
            this._addOperation(parseInt(nodes[nodes.length - 1].getAttribute('data-id')) + 1, screens);
            if (document.querySelectorAll('.operation').length >= 2) {
                document.querySelector(`.add_fields`).style.display = 'none';
            }
        });
        this._addOperation(0, screens);
        document.querySelector(`.send`).addEventListener('click', async (event) => {
            const fields = [];
            const allSelectors = document.querySelectorAll('.operation');
            for (let i = 0; i < allSelectors.length; i++) {
                const id = allSelectors[i].querySelector('.formControlInput') != null ? allSelectors[i].querySelector('.formControlInput').value : null;
                const valueFrom = allSelectors[i].querySelector('.from') != null ? allSelectors[i].querySelector('.from').value : null;
                const valueTo = allSelectors[i].querySelector('.to') != null ? allSelectors[i].querySelector('.to').value : null;
                const valueStep = allSelectors[i].querySelector('.step') != null ? allSelectors[i].querySelector('.step').value : null;
                if (id != null && valueFrom != null && valueFrom != "" && !isNaN(valueFrom) && valueTo != null && valueTo != "" && !isNaN(valueTo) && valueStep != "" && valueStep != null && !isNaN(valueStep)) {
                    const field = {
                        "id": id,
                        "from": parseFloat(valueFrom),
                        "to": parseFloat(valueTo),
                        "step": parseFloat(valueStep)
                    }
                    fields.push(field);
                }
            }

            if (fields.length > 0) {
                document.getElementById('splash').dataset.visible = true;
                const bodyData = `{
                    "username": ${sessionStorage.lcoe_loginhash},
                    "project_id": "${sessionStorage.lcoe_selected}",
                    "fields": ${JSON.stringify(fields)}
                }`;
                let rawResponse = await fetch(`${location.href}webresources/lcoeF3/parameterVariation`, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: bodyData
                });
                const result = await rawResponse.json();
                if (result.status === 200) {
                    let head = `<th>${document.querySelectorAll('.formControlInput').filter(e => e.selectedOptions[0].value == result.data.field)[0].selectedOptions[0].textContent}</th>`;
                    if (result.data.data[0].subfields != null) {
                        head += `<th>${document.querySelectorAll('.formControlInput').filter(e => e.selectedOptions[0].value == result.data.data[0].subfields.field)[0].selectedOptions[0].textContent}</th>`;
                    }
                    head += `<th>LCOE</th>`;
                    let body = ``;

                    for (let i = 0; i < result.data.data.length; i++) {
                        if (result.data.data[i].subfields != null) {
                            for (let j = 0; j < result.data.data[i].subfields.data.length; j++) {
                                body += `<tr>`;
                                body += `<td>${result.data.data[i].field_value}</td>`;
                                body += `<td>${result.data.data[i].subfields.data[j].field_value.toFixed(2).toString().replace(".", ",")}</td>`;
                                body += `<td>${result.data.data[i].subfields.data[j].lcoe_value.toFixed(4).toString().replace(".", ",")}</td>`;
                                body += `</tr>`;
                            }
                        } else {
                            body += `<tr>`;
                            body += `<td>${result.data.data[i].field_value.toFixed(2).toString().replace(".", ",")}</td>`;
                            body += `<td>${result.data.data[i].lcoe_value.toFixed(4).toString().replace(".", ",")}</td>`;
                            body += `</tr>`;
                        }
                    }
                    const table = `<table class="table table-bordered" style="margin-top: 50px; float: left;">
                        <thead>
                            <tr>
                                ${head}
                            </tr>
                        </thead>
                        <tbody>
                            ${body}
                        </tbody>
                    </table>`;
                    document.querySelector('.results').innerHTML = table;
                    document.getElementById('splash').dataset.visible = false;
                } else {
                    document.getElementById('splash').dataset.visible = false;
                    this.toastr.error(i18n("failedGettingVariations"), "");
                }
            }
        });
    }

    _addOperation(index, screens) {
        const operation = `
        <div class="operation operation${index}" data-id="${index}">
            <div class="row">
                <div style="width: ${index == 0 ? '100%' : 'calc(100% - 70px)'};">
                    <div class="row">
                        <div class="col">
                            <label for="formControlInputs${index}" class="formLabel">Inputs</label>
                            <div class="input-group input-selector mb-3">
                                <select id="formControlInputs${index}" class="form-select formControlInputs">
                                    ${this.options}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="inputsInput row">
                        <div class="col">
                            <label for="formControlInput${index}" class="formLabel">Input</label>
                            <div class="input-group input-selector mb-3">
                                <select id="formControlInput${index}" class="form-select formControlInput"></select>
                            </div>
                        </div>
                    </div>
                    <div class="fromtostep">
                        <div class="row">
                            <div class="col-md-3">
                                <label for="from${index}" class="formLabel">From</label>
                                <input id="from${index}" class="form-control from" type="number" />
                            </div>
                            <div class="col-md-3">
                                <label for="to${index}" class="formLabel">To</label>
                                <input id="to${index}" class="form-control to" type="number" />
                            </div>
                            <div class="col-md-4">
                                <label for="step${index}" class="formLabel">Step</label>
                                <input id="step${index}" class="form-control step" type="number" step=".01" />
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width: ${index == 0 ? '0%; display: none' : '70px'};">
                    <button type="button" class="btn btn-delete delete" data-id="${index}"><i data-id="${index}" class="fa fa-times"></i></button>
                </div>
            </div>
        </div>`;
        document.querySelector('.operations').insertAdjacentHTML(
            'beforeend', operation
        );
        document.querySelector(`.operation${index} .inputsInput`).style.display = 'none';
        document.querySelector(`.operation${index} .fromtostep`).style.display = 'none';
        document.querySelector(`.operation${index} .formControlInputs`).addEventListener('change', async (event) => {
            let opts = '<option style="display: none">-</option>';
            for (let i = 0; i < screens[event.target.value].screens[0].forms.length; i++) {
                if (screens[event.target.value].screens[0].forms[i].category_en != "") {
                    opts = opts + `<optgroup label="${screens[event.target.value].screens[0].forms[i].category_en}">`;
                }
                for (let j = 0; j < screens[event.target.value].screens[0].forms[i].form_data.length; j++) {
                    if (screens[event.target.value].screens[0].forms[i].form_data[j].data_type == "DEC") {
                        opts = opts + `<option value="${screens[event.target.value].screens[0].forms[i].form_data[j].id}">${screens[event.target.value].screens[0].forms[i].form_data[j].name_en} (${screens[event.target.value].screens[0].forms[i].form_data[j].unit})</option>`;
                    }
                }
                if (screens[event.target.value].screens[0].forms[i].category_en != "") {
                    opts = opts + `</optgroup>`;
                }
            }
            document.querySelector(`.operation${index} .inputsInput .form-select`).innerHTML = opts;
            document.querySelector(`.operation${index} .inputsInput`).style.display = 'block';
            document.querySelector(`.operation${index} .fromtostep`).style.display = 'none';
            document.querySelector(`.operation${index} .fromtostep .from`).value = "";
            document.querySelector(`.operation${index} .fromtostep .to`).value = "";
            document.querySelector(`.operation${index} .fromtostep .step`).value = "";
            document.querySelector(`.operation${index} .formControlInput`).addEventListener('change', async (event) => {
                document.querySelector(`.operation${index} .fromtostep .from`).value = "";
                document.querySelector(`.operation${index} .fromtostep .to`).value = "";
                document.querySelector(`.operation${index} .fromtostep .step`).value = "";
                /*document.querySelector(`.operation${index} .fromtostep .step`).addEventListener("input", function () {
                    this.value = this.value.replace(/,/g, ".");
                }, false);*/
                document.querySelector(`.operation${index} .fromtostep`).style.display = 'block';
            }, this);
        }, this);
        document.querySelector(`.operation${index} .delete`).addEventListener('click', async (event) => {
            const id = event.target.getAttribute("data-id");
            document.querySelector(`.operation${id}`).remove();
            if (document.querySelectorAll('.operation').length == 1) {
                document.querySelector(`.add_fields`).style.display = 'block';
            }
        });
    }

    async _fillSensitivityAnalysisContainer(forms, screens) {
        const rawResponse = await fetch(`${location.href}webresources/lcoeF3/getInput?` + new URLSearchParams({
            username: sessionStorage.lcoe_loginhash,
            projectid: sessionStorage.lcoe_selected,
            form_id: 1,
            input_id: 0
        }), {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        let result = await rawResponse.json();
        document.querySelector('.container-xxl .card-body #content').innerHTML = `<div id="operationsContainer" class="operationsContainer" data-id="101"></div>`;
        document.querySelector('.container-xxl h2').innerText = `${i18n('sensitivityAnalysis')}`;
        this.options = '<option style="display: none">-</option>';
        for (let i = 0; i < forms.length; i++) {
            if (result.data.data.length > 1 && i == 1) {
                continue;
            }
            this.options = this.options + `<option value="${forms[i].id}">${forms[i]['name_' + this.modules.localization.getLocale().split('-')[0]]}</option>`;
        }
        document.querySelector('#operationsContainer').innerHTML = `<p class="add_fields" style="font-size: 14px; font-weight: bold;">Add fields <button class="add"><i class="fa fa-plus"></i></button></p><div class='operations'></div><div class="buttons" style="padding-left: 0px; float: left; width: 100%">
            <button type="button" class="btn primary send">${i18n('send')}</button>
        </div><div class="results"><div class="row"><div class="col-md-6" style="margin-top: 30px;"><canvas id="0"></canvas></div></div></div>`;
        document.querySelector(`.add`).addEventListener('click', async (event) => {
            const nodes = document.querySelectorAll('.operation');
            this._addSensitivityOperation(parseInt(nodes[nodes.length - 1].getAttribute('data-id')) + 1, screens);
        });
        this._addSensitivityOperation(0, screens);
        document.querySelector(`.send`).addEventListener('click', async (event) => {
            const fields = [];
            const allSelectors = document.querySelectorAll('.operation');
            for (let i = 0; i < allSelectors.length; i++) {
                if (allSelectors[i].querySelector(`.formControlInputs`).value == 1) {
                    const id = "WE01";
                    const valueFirst = allSelectors[i].querySelector('.firstsecondnameweather .first').files;
                    const valueSecond = allSelectors[i].querySelector('.firstsecondnameweather .second').files;
                    const valueName = allSelectors[i].querySelector('.firstsecondnameweather .name') != null ? allSelectors[i].querySelector('.firstsecondnameweather .name').value : null;
                    if (id != null && valueFirst.length == 1 && valueSecond.length == 1 && valueName != "" && valueName != null) {
                        const file1 = valueFirst[0];
                        const file2 = valueSecond[0];

                        const base64File1 = await this.getBase64(file1);
                        const base64File2 = await this.getBase64(file2);
                        const field = {
                            "id": id,
                            "first": base64File1.replace(/^data:.+;base64,/, ''),
                            "second": base64File2.replace(/^data:.+;base64,/, ''),
                            "name": valueName
                        }
                        fields.push(field);
                    }
                } else {
                    const id = allSelectors[i].querySelector('.formControlInput') != null ? allSelectors[i].querySelector('.formControlInput').value : null;
                    const valueFirst = allSelectors[i].querySelector('.firstsecondname .first') != null ? allSelectors[i].querySelector('.firstsecondname .first').value : null;
                    const valueSecond = allSelectors[i].querySelector('.firstsecondname .second') != null ? allSelectors[i].querySelector('.firstsecondname .second').value : null;
                    const valueName = allSelectors[i].querySelector('.firstsecondname .name') != null ? allSelectors[i].querySelector('.firstsecondname .name').value : null;
                    if (id != null && valueFirst != null && valueFirst != "" && !isNaN(valueFirst) && valueSecond != null && valueSecond != "" && !isNaN(valueSecond) && valueName != "" && valueName != null) {
                        const field = {
                            "id": id,
                            "first": parseFloat(valueFirst),
                            "second": parseFloat(valueSecond),
                            "name": valueName
                        }
                        fields.push(field);
                    }
                }
                if (fields.length > 0) {
                    document.getElementById('splash').dataset.visible = true;
                    const bodyData = `{
                        "username": ${sessionStorage.lcoe_loginhash},
                        "project_id": "${sessionStorage.lcoe_selected}",
                        "fields": ${JSON.stringify(fields)}
                    }`;
                    let rawResponse = await fetch(`${location.href}webresources/lcoeF3/sensibilityAnalysis`, {
                        method: 'post',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: bodyData
                    });
                    const result = await rawResponse.json();
                    if (result.status === 200) {
                        const baseLcoe = result.data.base_lcoe;
                        const graphData = [];
                        for (let i = 0; i < result.data.data.length; i++) {
                            let value0 = result.data.data[i].data[0].lcoe_variation;
                            if (value0 < 0) {
                                value0 = value0 * -1;
                            }
                            let value1 = result.data.data[i].data[1].lcoe_variation;
                            if (value1 < 0) {
                                value1 = value1 * -1;
                            }
                            if (result.data.data[i].data[0].lcoe_value <= baseLcoe && result.data.data[i].data[1].lcoe_value >= baseLcoe) {
                                graphData.push({
                                    name: result.data.data[i].name,
                                    units: result.data.data[i].units,
                                    field_values: [result.data.data[i].data[0].field_value, result.data.data[i].data[1].field_value],
                                    values: [value0 * -1, value1]
                                });
                            } else if (result.data.data[i].data[1].lcoe_value <= baseLcoe && result.data.data[i].data[0].lcoe_value >= baseLcoe) {
                                graphData.push({
                                    name: result.data.data[i].name,
                                    units: result.data.data[i].units,
                                    field_values: [result.data.data[i].data[1].field_value, result.data.data[i].data[0].field_value],
                                    values: [value1 * -1, value0]
                                });
                            } else if (result.data.data[i].data[1].lcoe_value <= baseLcoe && result.data.data[i].data[0].lcoe_value <= baseLcoe) {
                                graphData.push({
                                    name: result.data.data[i].name,
                                    units: result.data.data[i].units,
                                    field_values: [result.data.data[i].data[1].field_value, result.data.data[i].data[0].field_value],
                                    values: result.data.data[i].data[0].lcoe_variation < result.data.data[i].data[1].lcoe_variation ?
                                        [value0 * -1, value1 * -1] :
                                        [value1 * -1, value0 * -1]
                                });
                            } else if (result.data.data[i].data[1].lcoe_value >= baseLcoe && result.data.data[i].data[0].lcoe_value >= baseLcoe) {
                                graphData.push({
                                    name: result.data.data[i].name,
                                    units: result.data.data[i].units,
                                    field_values: [result.data.data[i].data[1].field_value, result.data.data[i].data[0].field_value],
                                    values: result.data.data[i].data[1].lcoe_variation > result.data.data[i].data[0].lcoe_variation ?
                                        [value0, value1] :
                                        [value1, value0]
                                });
                            }
                        }
                        const barChartData = {
                            labels: graphData.map(e => `${e.name} ${e.field_values[0]}/${e.field_values[1]} ${typeof (e.units) === "undefined" || e.units == null ? "" : e.units}`),
                            datasets: [
                                {
                                    label: "",
                                    stack: "Stack 0",
                                    backgroundColor: this.chartColors[0],
                                    data: graphData.map(e => e.values[0] < 0 && e.values[1] < 0 ? [e.values[0], e.values[1]] : e.values[0] > 0 && e.values[1] > 0 ? 0 : e.values[0]),
                                    borderWidth: 1,
                                    barPercentage: 0.5
                                },
                                {
                                    label: "",
                                    stack: "Stack 0",
                                    backgroundColor: this.chartColors[1],
                                    data: graphData.map(e => e.values[0] < 0 && e.values[1] < 0 ? 0 : e.values[0] > 0 && e.values[1] > 0 ? [e.values[0], e.values[1]] : e.values[1]),
                                    borderWidth: 1,
                                    barPercentage: 0.5
                                }
                            ],
                        };
                        const options = {
                            indexAxis: 'y',
                            maintainAspectRatio: false,
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (c) => {
                                            const value = Number(c.raw);
                                            const positiveOnly = value < 0 ? -value : value;
                                            return `${c.dataset.label}: ${positiveOnly.toString()}`;
                                        }
                                    }
                                },
                                legend: {
                                    display: false
                                }
                            },
                            scales: {
                                x: {
                                    ticks: {
                                        callback: (v) => v + "%",
                                    }
                                },
                                y: {
                                    grid: {
                                        display: false
                                    }
                                }
                            }
                        };
                        let chartStatus = Chart.getChart('0');
                        if (chartStatus != undefined) {
                            chartStatus.destroy();
                        }
                        const chart = new Chart(document.getElementById('0'), {
                            type: "bar",
                            data: barChartData,
                            options: options
                        });
                        document.getElementById('splash').dataset.visible = false;
                    } else {
                        document.getElementById('splash').dataset.visible = false;
                        this.toastr.error(i18n("failedGettingSensitivity"), "");
                    }
                }
            }
        });
    }

    _addSensitivityOperation(index, screens) {
        const operation = `
        <div class="operation operation${index}" data-id="${index}">
            <div class="row">
                <div style="width: ${index == 0 ? '100%' : 'calc(100% - 70px)'};">
                    <div class="row">
                        <div class="col">
                            <label for="formControlInputs${index}" class="formLabel">Inputs</label>
                            <div class="input-group input-selector mb-3">
                                <select id="formControlInputs${index}" class="form-select formControlInputs">
                                    ${this.options}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="inputsInput row">
                        <div class="col">
                            <label for="formControlInput${index}" class="formLabel">Input</label>
                            <div class="input-group input-selector mb-3">
                                <select id="formControlInput${index}" class="form-select formControlInput"></select>
                            </div>
                        </div>
                    </div>
                    <div class="firstsecondname">
                        <div class="row">
                            <div class="col-md-3">
                                <label for="first${index}" class="formLabel">Initial</label>
                                <input id="first${index}" class="form-control first" type="number" />
                            </div>
                            <div class="col-md-3">
                                <label for="second${index}" class="formLabel">Final</label>
                                <input id="second${index}" class="form-control second" type="number" />
                            </div>
                            <div class="col-md-4">
                                <label for="name${index}" class="formLabel">Name</label>
                                <input id="name${index}" class="form-control name" type="text" />
                            </div>
                        </div>
                    </div>
                    <div class="firstsecondnameweather">
                        <div class="row">
                            <div class="col">
                                <label for="first${index}" class="formLabel">Initial</label>
                                <div class="input-group custom-file-button">
                                    <label class="input-group-text" for="inputGroupFileFirst${index}">Select file</label>
                                    <input type="file" class="form-control first" id="inputGroupFileFirst${index}" accept=".csv">
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col">
                                <label for="second${index}" class="formLabel">Final</label>
                                <div class="input-group custom-file-button">
                                    <label class="input-group-text" for="inputGroupFileSecond${index}">Select file</label>
                                    <input type="file" class="form-control second" id="inputGroupFileSecond${index}" accept=".csv">
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col">
                                <label for="name${index}" class="formLabel">Name</label>
                                <input id="name${index}" class="form-control name" type="text" />
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width: ${index == 0 ? '0%; display: none' : '70px'};">
                    <button type="button" class="btn btn-delete delete" data-id="${index}"><i data-id="${index}" class="fa fa-times"></i></button>
                </div>
            </div>
        </div>`;

        document.querySelector('.operations').insertAdjacentHTML(
            'beforeend', operation
        );
        document.querySelector(`.operation${index} .inputsInput`).style.display = 'none';
        document.querySelector(`.operation${index} .firstsecondname`).style.display = 'none';
        document.querySelector(`.operation${index} .firstsecondnameweather`).style.display = 'none';
        document.querySelector(`.operation${index} .formControlInputs`).addEventListener('change', async (event) => {
            if (screens[event.target.value].screens[0].name_en == "Weather") {
                document.querySelector(`.operation${index} .firstsecondname`).style.display = 'none';
                document.querySelector(`.operation${index} .firstsecondnameweather`).style.display = 'block';
                document.querySelector(`.operation${index} .inputsInput .form-select`).innerHTML = "";
                document.querySelector(`.operation${index} .inputsInput`).style.display = 'none';
            } else {
                let opts = '<option style="display: none">-</option>';
                for (let i = 0; i < screens[event.target.value].screens[0].forms.length; i++) {
                    if (screens[event.target.value].screens[0].forms[i].category_en != "") {
                        opts = opts + `<optgroup label="${screens[event.target.value].screens[0].forms[i].category_en}">`;
                    }
                    for (let j = 0; j < screens[event.target.value].screens[0].forms[i].form_data.length; j++) {
                        if (screens[event.target.value].screens[0].forms[i].form_data[j].data_type == "DEC") {
                            opts = opts + `<option value="${screens[event.target.value].screens[0].forms[i].form_data[j].id}">${screens[event.target.value].screens[0].forms[i].form_data[j].name_en} (${screens[event.target.value].screens[0].forms[i].form_data[j].unit})</option>`;
                        }
                    }
                    if (screens[event.target.value].screens[0].forms[i].category_en != "") {
                        opts = opts + `</optgroup>`;
                    }
                }
                document.querySelector(`.operation${index} .inputsInput .form-select`).innerHTML = opts;
                document.querySelector(`.operation${index} .inputsInput`).style.display = 'block';
                document.querySelector(`.operation${index} .firstsecondname`).style.display = 'none';
                document.querySelector(`.operation${index} .firstsecondnameweather`).style.display = 'none';
                document.querySelector(`.operation${index} .firstsecondname .first`).value = "";
                document.querySelector(`.operation${index} .firstsecondname .second`).value = "";
                document.querySelector(`.operation${index} .firstsecondname .name`).value = "";
                document.querySelector(`.operation${index} .formControlInput`).addEventListener('change', async (event) => {
                    document.querySelector(`.operation${index} .firstsecondname .first`).value = "";
                    document.querySelector(`.operation${index} .firstsecondname .second`).value = "";
                    document.querySelector(`.operation${index} .firstsecondname .name`).value = "";
                    document.querySelector(`.operation${index} .firstsecondname`).style.display = 'block';
                }, this);
            }
        }, this);
        document.querySelector(`.operation${index} .delete`).addEventListener('click', async (event) => {
            const id = event.target.getAttribute("data-id");
            document.querySelector(`.operation${id}`).remove();
        });
    }
}